<ng-container *ngIf="isTimeOutError; else errorTmp">
    <app-illustration-message size="sm"
                              iconName="clock"
                              [circleColor]="['warning'|color, .4]"
                              [title]="'Please try again'"
                              caption="For best results, adjust the filters to narrow your search"
                              class="my-auto">
    </app-illustration-message>
</ng-container>

<ng-template #errorTmp>
    <app-illustration-message size="sm"
                              iconName="times"
                              [circleColor]="['danger'|color, .33]"
                              [title]="errorMsg"
                              class="my-auto">
    </app-illustration-message>
</ng-template>
